var exports = {
  "D": "title___kY5U_",
};

module.exports = exports;
